import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IoniconsFilled, NavItem, NavItemsId, PtEntity} from '@pt/pt-models';

@Component({
  selector: 'pt-download-selected-rows',
  templateUrl: './download-selected-rows.component.html'
})
export class DownloadSelectedRowsComponent {
  @Input() entity: PtEntity;
  @Input() selectedRows: any[] = [];
  @Output() clickAction = new EventEmitter<NavItem>();

  public IconDownload = IoniconsFilled.download;

  clickBtn() {
    const a: any = {id: NavItemsId.DOWNLOAD};
    this.clickAction.emit(a);
  }
}
